const mapPagerApiToAntdPager = (pagerApi: any, antdPager: any) => {
  antdPager.total = pagerApi.totalItems;
  antdPager.current = pagerApi.currentPage;
  antdPager.pageSize = pagerApi.pageSize;

  return antdPager;
};

const sortByProperty = (property: any, order = 'asc') => {
  return function(a: any, b: any) {
    let compare;
    if (a[property] > b[property]) compare = 1;
    else if (a[property] < b[property]) compare = -1;
    else compare = 0;

    order === 'asc' ? (compare *= 1) : (compare *= -1);
    return compare;
  };
};

/**
 * usually use for map status Id/Code to status object
 * @param value
 * @param arr
 */
const mapValueToObject = (value: any, arr: any) => {
  return arr[value];
};

export default {
  mapPagerApiToAntdPager,
  sortByProperty,
  mapValueToObject,
};
